// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"162":"3615c69b","349":"79f6c410","474":"8eebf550","655":"18b6580a"}[chunkId] + ".chunk.css";
};